module.exports = __webpack_public_path__ + "static/media/Home-TealBlocks1.0bc00806.svg";